const base = {
    // url: 'http://api.cn-imie.com'
	url: 'http://api.cn-imie.com'
}
export default base